<ng-template [ngIf]="airLineFilterForm !== 1">
  <form [formGroup]="airLineFilterForm">
    <div id="pnsrch" class="sidebar-pnsrch" style="display: inline-block">
      <div class="pnContent">
        <div class="pnclose">
          <div (click)="closePannel()"><i class="fa fa-chevron-circle-left fa1x"></i></div>
        </div>
        <h3>Filter Offers</h3>
        <div class="pd-10">
          <div id="filRw" class="row">
            <div class="col-sm-12">
              <div class="customSlider">
                <h4>Time</h4>
                <div *ngFor="let slider of boundSliders; let sliderIndex = index">
                  <span class="sliderTitle">{{ slider.label }}</span>
                  <ngx-slider [(value)]="slider.startTime" [(highValue)]="slider.endTime" [options]="timeSliderOprion"> </ngx-slider>
                </div>
                <!--<span class="sliderTitle">OutBound</span>
                <ngx-slider [(value)]="boundSliders[0]['startTime']" [(highValue)]="boundSliders[0]['endTime']" [options]="timeSliderOprion"> </ngx-slider>

                <div style="margin-top: 6px" *ngIf="showInbound">
                  <span class="sliderTitle"> InBound</span>
                  <ngx-slider [(value)]="boundSliders[1]['startTime']" [(highValue)]="boundSliders[1]['endTime']" [options]="timeSliderOprion"> </ngx-slider>
                </div>-->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div>
                <h4>Airports</h4>
                <div class="flpn" formArrayName="airPort">
                  <div class="form-check" *ngFor="let p of inp_arr('airPort').controls; let i = index" [formGroupName]="i">
                    <input type="checkbox" class="form-check-input" formControlName="selected" id="cityCode" value="LHR" checked="" name="cityCode" />
                    <label class="form-check-label">{{ inp_arr_group_value('airPort', i, 'label') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div>
                <h4>Operating Carriers</h4>
                <div class="flpn" formArrayName="operater">
                  <div class="form-check" *ngFor="let p of inp_arr('operater').controls; let i = index" [formGroupName]="i">
                    <input type="checkbox" class="form-check-input" formControlName="selected" id="cityCode" value="LHR" checked="" name="cityCode" />
                    <label class="form-check-label">{{ inp_arr_group_value('operater', i, 'label') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div>
                <h4>Price Class</h4>
                <div class="flpn" formArrayName="priceClass">
                  <div class="form-check" *ngFor="let p of inp_arr('priceClass').controls; let i = index" [formGroupName]="i">
                    <input type="checkbox" class="form-check-input" formControlName="selected" id="cityCode" value="LHR" checked="" name="cityCode" />
                    <label class="form-check-label">{{ inp_arr_group_value('priceClass', i, 'label') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-sm-4"></div>
            <div class="col-sm-8">
              <button type="button" role="button" (click)="update_filter()" class="ba-btn ba-btn-vthin ba-btn-w100 pull-right"><i class="fas fa-sync"></i> Filter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
